import React from "react";
import "./styles.css";

import ButtonComponent from "../../atoms/ButtonComponent";

const InfoCharacter = (props) => {
    const {
        charLevel,
        thirdClassLevel,
        skillPoints,
        cooldown,
        handleChangeCharLevel,
        handleChangeCooldown,
        handleChangeThidClassLevel,
        handleReset,
        handleShare,
        handleClick,
    } = props;

    return (
        <div id="infoCharacter">
            <span>Nível</span>
            <input
                id="charLevel"
                value={charLevel}
                type="number"
                min={1}
                max={99}
                onChange={handleChangeCharLevel}
            />
            <span>Terceira Classe (Lv. 99)</span>
            <input
                id="thirdClassLevel"
                value={thirdClassLevel}
                type="number"
                min={1}
                max={20}
                onChange={handleChangeThidClassLevel}
            />
            <span>Resfriamento</span>
            <input
                id="cooldown"
                value={cooldown}
                type="number"
                min={1}
                max={70}
                onChange={handleChangeCooldown}
            />
            <span>Pontos de Skill: {skillPoints}</span>
            <ButtonComponent
                id={"resetButton"}
                handleClick={handleReset}
                title={"Reset Build"}
            />
            <ButtonComponent
                id={"shareButton"}
                handleClick={handleShare}
                title={"Compartilhar Build"}
            />
            <button onClick={handleClick} className="attribute-button">
                Calculador de Atributos
            </button>
        </div>
    );
};

export default React.memo(InfoCharacter);
